export interface Country {
  country: string;
  code: string;
  iso: string;
  flag: string;
}

export const COUNTRIES: Country[] = [
  { country: "Argentina", code: "+54", iso: "AR", flag: "🇦🇷" },
  { country: "Australia", code: "+61", iso: "AU", flag: "🇦🇺" },
  { country: "Austria", code: "+43", iso: "AT", flag: "🇦🇹" },
  { country: "Bangladesh", code: "+880", iso: "BD", flag: "🇧🇩" },
  { country: "Belgium", code: "+32", iso: "BE", flag: "🇧🇪" },
  { country: "Belize", code: "+501", iso: "BZ", flag: "🇧🇿" },
  { country: "Bolivia", code: "+591", iso: "BO", flag: "🇧🇴" },
  { country: "Brazil", code: "+55", iso: "BR", flag: "🇧🇷" },
  { country: "Canada", code: "+1", iso: "CA", flag: "🇨🇦" },
  { country: "Chile", code: "+56", iso: "CL", flag: "🇨🇱" },
  { country: "China", code: "+86", iso: "CN", flag: "🇨🇳" },
  { country: "Colombia", code: "+57", iso: "CO", flag: "🇨🇴" },
  { country: "Costa Rica", code: "+506", iso: "CR", flag: "🇨🇷" },
  { country: "Czech Republic", code: "+420", iso: "CZ", flag: "🇨🇿" },
  { country: "Denmark", code: "+45", iso: "DK", flag: "🇩🇰" },
  { country: "Ecuador", code: "+593", iso: "EC", flag: "🇪🇨" },
  { country: "Egypt", code: "+20", iso: "EG", flag: "🇪🇬" },
  { country: "El Salvador", code: "+503", iso: "SV", flag: "🇸🇻" },
  { country: "Finland", code: "+358", iso: "FI", flag: "🇫🇮" },
  { country: "France", code: "+33", iso: "FR", flag: "🇫🇷" },
  { country: "Germany", code: "+49", iso: "DE", flag: "🇩🇪" },
  { country: "Greece", code: "+30", iso: "GR", flag: "🇬🇷" },
  { country: "Guatemala", code: "+502", iso: "GT", flag: "🇬🇹" },
  { country: "Honduras", code: "+504", iso: "HN", flag: "🇭🇳" },
  { country: "Hungary", code: "+36", iso: "HU", flag: "🇭🇺" },
  { country: "India", code: "+91", iso: "IN", flag: "🇮🇳" },
  { country: "Indonesia", code: "+62", iso: "ID", flag: "🇮🇩" },
  { country: "Ireland", code: "+353", iso: "IE", flag: "🇮🇪" },
  { country: "Israel", code: "+972", iso: "IL", flag: "🇮🇱" },
  { country: "Italy", code: "+39", iso: "IT", flag: "🇮🇹" },
  { country: "Japan", code: "+81", iso: "JP", flag: "🇯🇵" },
  { country: "Kenya", code: "+254", iso: "KE", flag: "🇰🇪" },
  { country: "Malaysia", code: "+60", iso: "MY", flag: "🇲🇾" },
  { country: "Mexico", code: "+52", iso: "MX", flag: "🇲🇽" },
  { country: "Netherlands", code: "+31", iso: "NL", flag: "🇳🇱" },
  { country: "New Zealand", code: "+64", iso: "NZ", flag: "🇳🇿" },
  { country: "Nicaragua", code: "+505", iso: "NI", flag: "🇳🇮" },
  { country: "Nigeria", code: "+234", iso: "NG", flag: "🇳🇬" },
  { country: "Norway", code: "+47", iso: "NO", flag: "🇳🇴" },
  { country: "Pakistan", code: "+92", iso: "PK", flag: "🇵🇰" },
  { country: "Panama", code: "+507", iso: "PA", flag: "🇵🇦" },
  { country: "Paraguay", code: "+595", iso: "PY", flag: "🇵🇾" },
  { country: "Peru", code: "+51", iso: "PE", flag: "🇵🇪" },
  { country: "Philippines", code: "+63", iso: "PH", flag: "🇵🇭" },
  { country: "Poland", code: "+48", iso: "PL", flag: "🇵🇱" },
  { country: "Portugal", code: "+351", iso: "PT", flag: "🇵🇹" },
  { country: "Romania", code: "+40", iso: "RO", flag: "🇷🇴" },
  { country: "Russia", code: "+7", iso: "RU", flag: "🇷🇺" },
  { country: "Saudi Arabia", code: "+966", iso: "SA", flag: "🇸🇦" },
  { country: "Singapore", code: "+65", iso: "SG", flag: "🇸🇬" },
  { country: "Slovakia", code: "+421", iso: "SK", flag: "🇸🇰" },
  { country: "South Africa", code: "+27", iso: "ZA", flag: "🇿🇦" },
  { country: "South Korea", code: "+82", iso: "KR", flag: "🇰🇷" },
  { country: "Spain", code: "+34", iso: "ES", flag: "🇪🇸" },
  { country: "Sweden", code: "+46", iso: "SE", flag: "🇸🇪" },
  { country: "Switzerland", code: "+41", iso: "CH", flag: "🇨🇭" },
  { country: "Thailand", code: "+66", iso: "TH", flag: "🇹🇭" },
  { country: "Turkey", code: "+90", iso: "TR", flag: "🇹🇷" },
  { country: "Ukraine", code: "+380", iso: "UA", flag: "🇺🇦" },
  { country: "United Arab Emirates", code: "+971", iso: "AE", flag: "🇦🇪" },
  { country: "United Kingdom", code: "+44", iso: "GB", flag: "🇬🇧" },
  { country: "United States", code: "+1", iso: "US", flag: "🇺🇸" },
  { country: "Uruguay", code: "+598", iso: "UY", flag: "🇺🇾" },
  { country: "Venezuela", code: "+58", iso: "VE", flag: "🇻🇪" },
  { country: "Vietnam", code: "+84", iso: "VN", flag: "🇻🇳" },
];